<template>
  <article>
    <div class="c_single_movie">
      <pdf-reader v-if="flag" :url="src" :contents="contents"></pdf-reader>
    </div>
    <div v-if="video.has_attachment || contents.video_attach">
      <div class="c_single_dl" v-if="loading">
        <div class="c_btn -gray c_single_dl_btn">
          <span class="icon-download"></span>
          ダウンロード中
          <div :class="{ c_load: loading }"></div>
        </div>
      </div>
      <div class="c_single_dl" v-else>
        <a class="c_btn c_single_dl_btn" @click="getAttachment">
          <span class="icon-download"></span>
          補助資料ダウンロード
        </a>
      </div>
    </div>
  </article>
</template>

<script>
import PdfReader from "@/components/PDFReader";
import { jc3CloudFrontDomain } from "@/../config.json";
//import axios from "axios";

export default {
  components: {
    PdfReader
  },
  props: {
    contents: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  data() {
    return {
      video: {},
      windowWidth: window.innerWidth,
      timer: "",
      first: true,
      loading: false,
      flag: false
    };
  },
  mounted() {
    window.addEventListener("resize", this.calculateWindowWidth);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calculateWindowWidth);
  },
  computed: {
    src() {
      return `https://${jc3CloudFrontDomain}/${this.contents.key}`;
    },
    playerHeight: function() {
      return (this.playerWidth * 9) / 16;
    },
    playerWidth: function() {
      if (this.windowWidth > 1280) {
        return 1280;
      } else {
        return this.windowWidth;
      }
    },
    attachmentURL: function() {
      return "";
    }
  },
  methods: {
    init() {
      this.flag = true;
    },
    getFileNameFromContentDisposition(disposition) {
      const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/; // 正規表現でfilenameを抜き出す
      const matches = filenameRegex.exec(disposition);
      if (matches != null && matches[1]) {
        const fileName = matches[1].replace(/['"]/g, "");
        return decodeURI(fileName); // 日本語対応
      } else {
        return null;
      }
    },
    responseFileDownload(response, filename) {
      const url = URL.createObjectURL(new Blob([response.data]), {
        type: response.headers["content-type"]
      });
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      link.click();
      URL.revokeObjectURL(url);
    },
    getAttachment() {
      if (this.contents.video_type === 1) {
        this.loading = true;
        this.$authAxios
          .get(this.attachmentURL, {
            responseType: "blob"
          })
          .then(response => {
            const filename = this.getFileNameFromContentDisposition(
              response.headers["content-disposition"]
            );
            this.responseFileDownload(response, filename);
          })
          .catch(error => {
            console.log(error);
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        window.open(this.attachmentURL);
      }
    },
    calculateWindowWidth() {
      this.windowWidth = window.innerWidth;
    },
    savelog(status) {
      if (this.$refs.player.player.isPlaying() || status === "FINISH") {
        this.$authAxios.post("/api/log/video", {
          id: this.contents.id,
          currentTime: this.$refs.player.player.getCurrentTime(),
          duration: this.$refs.player.player.getDuration(),
          status: status
        });
      }
    },
    play() {
      if (this.first) {
        this.savelog("START");
        this.first = false;
      }
      clearInterval(this.timer);
      this.timer = setInterval(this.savelog.bind(this, "PLAYING"), 5000);
    },
    pause() {
      clearInterval(this.timer);
    },
    ended() {
      this.savelog("FINISH");
    }
  }
};
</script>
